import React from 'react'
import { useTranslation } from 'react-i18next'

import { useNavigate } from '@lib/react-router-dom'

import { Body1, Heading3 } from '@ui/Typography'

import { Button } from '@global/button/Button'

import styles from './PendingClassificationTest.module.scss'

export const PendingClassificationTest = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <div className={styles.card}>
		<div className={styles.container}>
			<Heading3>{t('Profile.Your reclassification application is under review')}</Heading3>
			<Body1 className={styles.description}>
				{t('Profile.The process may take up to 7 working days')}
			</Body1>
			<Button
				appearance='primary'
				size='L'
				onClick={() => navigate('/dashboard/traders-room/wallets')}
			>
				<Body1 className={styles.button} medium>
					{t('Back to Wallets')}
				</Body1>
			</Button>
		</div>
    </div>
  )
}
